import type { Subdesk } from "@/hooks/use-desk-migration";
import type { MetadataOption } from "@/hooks/use-itsm-metadata";

/**
 * Team picker options for a desk: "Any team" plus its teams.
 *
 * The Main Subdesk is left out: it stands for "no team", which is what the
 * desk rule already matches, and the backend refuses it on a rule.
 */
export function teamOptions(subdesks: Subdesk[] | undefined): MetadataOption[] {
  const teams = (subdesks ?? [])
    .filter((s) => !s.is_default)
    .map((s) => ({ value: s.id, label: s.name }));
  return [{ value: "", label: "Any team" }, ...teams];
}

/** The rule's `match.subdesk_id`: a team only counts alongside its desk. */
export function teamMatch(
  deskId: string | undefined,
  subdeskId: string | undefined,
): string | null {
  return deskId && subdeskId ? subdeskId : null;
}
